function RamenToBiiruLogo() {
  return (
    <img
      height="140"
      width="72"
      src="/logos/rtb-logo.png"
      className="w-full h-full object-contain max-h-[150px] max-md:mt-12 md:p-4"
      alt="Ramen to Biiru Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { RamenToBiiruLogo };
